/**
 * useMobile Hook
 *
 * Centralized mobile detection to avoid duplicating resize logic across components.
 * Uses 768px breakpoint to match Tailwind's `md:` breakpoint.
 *
 * Usage:
 *   const isMobile = useMobile();
 *   // Returns true when viewport width < 768px
 */
import { useState, useEffect } from "react";

// Match Tailwind's md: breakpoint
const MOBILE_BREAKPOINT = 768;

export function useMobile(): boolean {
  // Initialize with current window width (SSR-safe)
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined"
      ? window.innerWidth < MOBILE_BREAKPOINT
      : false,
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };

    // Listen for window resize
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile;
}

export default useMobile;
